// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"82bb1230","193":"908a1140","197":"5e5c9478","255":"cbcdf57a","428":"c5e27650","453":"3aa34de2","637":"90352051","801":"e27be3e3","927":"c3cc7b92"}[chunkId] + ".chunk.js";
};